import React, { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/apiClient";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = logged in

  useEffect(() => {
    if (!localStorage.getItem("vc_token")) { setUser(false); return; }
    client.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("vc_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await client.post("/auth/logout"); } catch {}
    localStorage.removeItem("vc_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}
